import { createStructuredSelector } from 'reselect';
import { selectAssemblyDataForCart } from 'shared/product_tabs/tab_assembly/slice/selectors';
import { selectStencilsDataForCart } from 'shared/product_tabs/tab_stencils/slice/selectors';
import { selectAccessoriesDataForCart } from 'shared/product_tabs/tab_accessories/slice/selectors';
import { selectBomDataForCart } from 'shared/product_tabs/tab_parts/slice/selectors';

export const selectAddingToCart = (state) => state.cart?.addingToCart;

export const selectApplyCouponCode = (state) => state.cart?.applyCouponCode;

export const selectEligibleCouponCode = (state) => state.cart?.couponCode;

export const selectNextOption = (state) => state.cart?.nextOption;

export const selectProductName = (state) => state.cart?.productName;

export const selectRemaining = (state) => state.cart?.remaining;

export const selectProgress = (state) => state.cart?.progress;

export const selectDataForCart = createStructuredSelector({
  addingToCart: selectAddingToCart,
  couponCode: selectEligibleCouponCode,
  applyCouponCode: selectApplyCouponCode,
  assembly: selectAssemblyDataForCart,
  stencils: selectStencilsDataForCart,
  accessories: selectAccessoriesDataForCart,
  parts: selectBomDataForCart,
});

export const selectDataForBlackFridayPromotion = createStructuredSelector({
  applyCouponCode: selectApplyCouponCode,
  couponCode: selectEligibleCouponCode,
  nextOption: selectNextOption,
  remaining: selectRemaining,
  progress: selectProgress,
  productName: selectProductName,
});